import React, { useState } from "react";
import "./TracerMain.css";
import { Container } from "react-bootstrap";
import TracerProgress from "../../Component/Sidebar/TracerProgress";

import TracerSidebar from "../../Component/Sidebar/TracerSidebar";
import TracerNavbar from "../../Component/Navbar/TracerNavbar";
import Footer from "../../Component/Footer/Footer";

import Chart from "../../Component/Chart/Chart";

const PortalCTQMain = () => {
  const [isActive, setActive] = useState(false);
  const toggleClass = () => {
    setActive(!isActive);
  };
  return (
    <>
      <div className="App">
        <div className="side-bar ">
          <TracerSidebar handleClick={toggleClass} isActive={isActive}/>
        </div>
        <div className="main w-100">
          <TracerNavbar isActive={isActive}/>
          <Container>
            <div className="head-select">
              <TracerProgress done={30} />

              <div className="main-select">
                <div className="portalCtq-body">
                  <div className="portalctq-cards">
                    <ul className="poprtalCtq-list">
                      <li className="portalCtq_items">
                        <div className="PortalCtq-Graph">
                          <Chart />
                        </div>
                        <div className="portalCtq-Retest">
                          <div className="retest-title">RFTEST_TX_RSSI</div>
                          <div className="retest-bar">
                            <div className="bar-test">CP:0</div>
                            <div className="bar-test">CPk:0</div>
                            <div className="bar-test">COUNT</div>
                          </div>
                        </div>
                      </li>
                      <li className="portalCtq_items">
                        <div className="PortalCtq-Graph">
                          <Chart />
                        </div>
                        <div className="portalCtq-Retest">
                          <div className="retest-title">RFTEST_TX_RSSI</div>
                          <div className="retest-bar">
                            <div className="bar-test">CP:0</div>
                            <div className="bar-test">CPk:0</div>
                            <div className="bar-test">COUNT</div>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <ul className="poprtalCtq-list">
                      <li className="portalCtq_items">
                        <div className="PortalCtq-Graph">
                          <Chart />
                        </div>
                        <div className="portalCtq-Retest">
                          <div className="retest-title">RFTEST_TX_RSSI</div>
                          <div className="retest-bar">
                            <div className="bar-test">CP:0</div>
                            <div className="bar-test">CPk:0</div>
                            <div className="bar-test">COUNT</div>
                          </div>
                        </div>
                      </li>
                      <li className="portalCtq_items">
                        <div className="PortalCtq-Graph">
                          <Chart />
                        </div>
                        <div className="portalCtq-Retest">
                          <div className="retest-title">RFTEST_TX_RSSI</div>
                          <div className="retest-bar">
                            <div className="bar-test">CP:0</div>
                            <div className="bar-test">CPk:0</div>
                            <div className="bar-test">COUNT</div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </Container>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default PortalCTQMain;
